/**
 * Ambiente e-CF del tenant (testecf | certecf | ecf) para armar la URL del QR
 * de consulta de timbre de la DGII.
 *
 * Sale de varinicial.ambienteecf vía /api/fiscal_ambienteecf (el backend cae a
 * DGII_AMBIENTE si la columna falta). Se pide una vez por usuario y empresa
 * fiscal (con multi-empresa cada RNC tiene su ambiente) y queda en caché del
 * módulo. Si la consulta falla se usa REACT_APP_DGII_AMBIENTE del
 * build, como antes.
 *
 *   const ambiente = useAmbienteEcf(); // null mientras carga
 */
import { useEffect, useState } from "react";
import { useMaterialUIController } from "context";
import { apiPost } from "lib/api";
import { useEmpresaFiscal } from "lib/empresaFiscal";

export const AMBIENTES_ECF = ["testecf", "certecf", "ecf"];
const AMBIENTE_BUILD = process.env.REACT_APP_DGII_AMBIENTE || "certecf";

// "usuario|empresa" -> Promise<ambiente>
const cache = new Map();

export function ambienteEcfValido(valor) {
  const amb = String(valor || "")
    .trim()
    .toLowerCase();
  return AMBIENTES_ECF.includes(amb) ? amb : "";
}

export function obtenerAmbienteEcf(usuario, password, empresa = 1) {
  if (!usuario) return Promise.resolve(AMBIENTE_BUILD);
  const clave = `${usuario}|${empresa}`;
  if (!cache.has(clave)) {
    // Un fallo no se cachea: el próximo QR vuelve a intentar.
    const fallo = () => {
      cache.delete(clave);
      return AMBIENTE_BUILD;
    };
    const promesa = apiPost("/api/fiscal_ambienteecf", { usuario, password, empresa })
      .then(({ ok, data }) => (ok && ambienteEcfValido(data.ambiente)) || fallo())
      .catch(fallo);
    cache.set(clave, promesa);
  }
  return cache.get(clave);
}

export function useAmbienteEcf() {
  const [controller] = useMaterialUIController();
  const { usuarioLog, claveLog } = controller;
  const { empresa } = useEmpresaFiscal();
  const [ambiente, setAmbiente] = useState(null);
  useEffect(() => {
    let vivo = true;
    obtenerAmbienteEcf(usuarioLog, claveLog, empresa).then((amb) => {
      if (vivo) setAmbiente(amb);
    });
    return () => {
      vivo = false;
    };
  }, [usuarioLog, claveLog, empresa]);
  return ambiente;
}
